export default {
      id: "sports_esports-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#sports_esports",
      toString: function () {
        return this.url;
      }
    }